import { useState } from 'react';
import axios from 'axios';

export const usePdfUrls = () => {
    const [pdfUrls, setPdfUrls] = useState({});
    const [loadingUrls, setLoadingUrls] = useState({});

    const fetchPdfUrl = async (documentId) => {
        try {
            setLoadingUrls(prev => ({ ...prev, [documentId]: true }));
            const pdfUrlResponse = await axios.post(
                `${process.env.REACT_APP_LAWS_BACKEND_HOST}/docs/v1/documents/longPdfUrl?documentId=${documentId}`
            );
            setLoadingUrls(prev => ({ ...prev, [documentId]: false }));
            return pdfUrlResponse.data;
        } catch (error) {
            console.error(`Error fetching PDF URL for document ${documentId}: `, error);
            setLoadingUrls(prev => ({ ...prev, [documentId]: false }));
            return null;
        }
    };

    const handleDocumentClick = async (documentId, e) => {
        e.preventDefault();
        const openPdf = (url) => {
            window.open(url, '_blank', 'noopener,noreferrer');
        };

        if (!pdfUrls[documentId]) {
            const pdfUrl = await fetchPdfUrl(documentId);
            if (pdfUrl) {
                setPdfUrls(prev => ({ ...prev, [documentId]: pdfUrl }));
                openPdf(pdfUrl);
            }
        } else {
            openPdf(pdfUrls[documentId]);
        }
    };

    return {
        pdfUrls,
        loadingUrls,
        fetchPdfUrl,
        handleDocumentClick
    };
}; 